import Hero from "../components/sections/Hero";
import Marquee from "../components/sections/Marquee";
import Stats from "../components/sections/Stats";
import Immersive from "../components/sections/Immersive";
import Defence from "../components/sections/Defence";
import VirtualProductions from "../components/sections/VirtualProductions";
import Showreel from "../components/sections/Showreel";
import ProjectsTeaser from "../components/sections/ProjectsTeaser";
import ContactSection from "../components/sections/ContactSection";

export default function HomePage() {
    return (
        <main data-testid="home-page">
            <Hero />
            <Marquee />
            <Stats />
            <Immersive />
            <Defence />
            <VirtualProductions />
            <Showreel />
            <ProjectsTeaser />
            <ContactSection />
        </main>
    );
}
